import {decorate, observable, action} from "mobx"
import {defaultTimePeriod} from "../../utils/utils"

export class TimePeriodStore {
  timePeriod = defaultTimePeriod

  setTimePeriod(days) {
    this.timePeriod = days
  }
}

decorate(TimePeriodStore, {
  timePeriod: observable,
  setTimePeriod: action,
})
